import api from "lib/api/api";

export const FETCH_STUDENT_REQUESTS_REQUEST = "FETCH_STUDENT_REQUESTS_REQUEST";
export const FETCH_STUDENT_REQUESTS_SUCCESS = "FETCH_STUDENT_REQUESTS_SUCCESS";
export const FETCH_STUDENT_REQUESTS_FAILURE = "FETCH_STUDENT_REQUESTS_FAILURE";

export const fetchStudentCourseRequests =
  (teacherCourseId, type = null) => async (dispatch) => {
    dispatch({ type: FETCH_STUDENT_REQUESTS_REQUEST, teacherCourseId });

    try {
      const endpoint = type
        ? `/admin/requests/${teacherCourseId}?type=${type}`
        : `/admin/requests/${teacherCourseId}`;

      const response = await api.get(endpoint);

      dispatch({
        type: FETCH_STUDENT_REQUESTS_SUCCESS,
        teacherCourseId,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_STUDENT_REQUESTS_FAILURE,
        teacherCourseId,
        payload:
          error.response?.data?.message ||
          "Failed to fetch student course requests",
      });
    }
  };

export const CLEAR_STUDENT_REQUESTS = "CLEAR_STUDENT_REQUESTS";
export const clearStudentCourseRequests = () => ({
  type: CLEAR_STUDENT_REQUESTS,
});
